import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from 'react-router-dom'; 
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

import moment from "moment";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "sr_no",
    },
  },
  {
    label: "Party Name",
    field: "party_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Party Name",
    },
  },
  {
    label: "Email",
    field: "email",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Email",
    },
  },
  {
    label: "Phone No.",
    field: "phone_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Phone No.",
    },
  },
  {
    label: "RECEIVABLE BALANCE",
    field: "rec_balance",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "RECEIVABLE BALANCE",
    },
  },
  {
    label: "PAYABLE BALANCE",
    field: "payable_balance",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "PAYABLE BALANCE",
    },
  },
];

let _loader = "glb-ldr-prt active";
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      total: 0,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      partyArrayList: [],
      partyGroupArray: [],
      selectedPartyId: "0",
      selectedGroupId: "0",
      selectedPartyName: "All Parties",
      selectedGroupName: "All Groups",
      showPartyDropdown: false,
      showGroupDropdown: false,
      errors: {
        name: "",
      },
    };
  }
 
  async componentDidMount() {
    this.getPartyList();
    this.getPartyGroupList();
    this.getSaleListData();
  }

  getPartyList() {
    let _url_GetData = global.userPartyList + "?company_id=" + this.state.company_id;
    console.log("Fetching Party List:", _url_GetData);
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        console.log("Party List Response:", responseJson);
        if (responseJson.success && responseJson.response) {
          this.setState({ partyArrayList: responseJson.response });
        }
      })
      .catch((error) => console.error("Party List Error: ", error));
  }

  getPartyGroupList() {
    const requestData = JSON.stringify({
      businessId: this.state.businessId,
      company_id: this.state.company_id,
    });
    console.log("Fetching Party Group List:", global.userPartyGroupList, "company_id:", this.state.company_id);
    PostData(global.userPartyGroupList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        console.log("Party Group Response:", responseJson);
        if (responseJson.response && responseJson.response.length > 0) {
          this.setState({ partyGroupArray: responseJson.response });
        } else {
          console.log("No party groups found or empty response");
        }
      })
      .catch((error) => console.error("Party Group List Error: ", error));
  }

  getSaleListData() {
    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      party_id: this.state.selectedPartyId,
      party_group_id: this.state.selectedGroupId,
    });
    PostData(global.userAllParty, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        console.log("API Response: ", responseJson);

        if (responseJson.success && responseJson.response && responseJson.response.length > 0) {
          this.setState(
            {
              partyArray: responseJson.response,
              isLoaded: true,
            },
            () => console.log("Updated State: ", this.state.partyArray)
          );
        } else {
          // Clear partyArray when no records found
          console.warn("API Response was unsuccessful or empty.");
          this.setState({ partyArray: [], isLoaded: true });
        }
      })
      .catch((error) => {
        console.error("API Error: ", error);
        this.setState({ error, partyArray: [], isLoaded: true });
      });
  }

  
  loadTranscListing() {
    let rows = [];

    if (this.state.partyArray && this.state.partyArray.length > 0) {
        console.log("Processing partyArray:", this.state.partyArray); // ✅ Debug log
        rows = this.state.partyArray.map((party, index) => {
            let recBalance = party.txtBalance === "Receivable" ? Math.abs(party.totalOutCome) || 0 : 0;
            let payableBalance = party.txtBalance === "Payable" ? Math.abs(party.totalOutCome) || 0 : 0;
            return {
                sr_no: index + 1,
                party_name: party.party_name || "N/A",
                email: party.party_email_id || "N/A",
                phone_no: party.party_contact_no || "N/A",
                rec_balance: (
                    <span style={{ color: recBalance > 0 ? "green" : "black" }}>
                        {numberFormat(recBalance)}
                    </span>
                ),
                payable_balance: (
                    <span style={{ color: payableBalance > 0 ? "red" : "black" }}>
                        {numberFormat(payableBalance)}
                    </span>
                ),
                credit_limit: 0, // Modify if another field exists
            };
        });
        console.log("Generated Table Rows:", rows); // ✅ Debug log
    } else {
        console.warn("Party Array is empty, no data to display!");
    }

    return {
        columns: columns,
        rows: rows,
    };
  }


  

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    }, () => this.getSaleListData());
  };

  handlePartyFilter = (partyId, partyName) => {
    this.setState({
      selectedPartyId: partyId,
      selectedPartyName: partyName,
      showPartyDropdown: false
    }, () => this.getSaleListData());
  };

  handleGroupFilter = (groupId, groupName) => {
    this.setState({
      selectedGroupId: groupId,
      selectedGroupName: groupName,
      showGroupDropdown: false
    }, () => this.getSaleListData());
  };

  togglePartyDropdown = () => {
    this.setState({ showPartyDropdown: !this.state.showPartyDropdown, showGroupDropdown: false });
  };

  toggleGroupDropdown = () => {
    this.setState({ showGroupDropdown: !this.state.showGroupDropdown, showPartyDropdown: false });
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }


  exportData = (event) =>{
    let _itemDetails = this.state.partyArray;
    try {
      let totalAmount = 0;

      _itemDetails = _itemDetails.map((data) => {
        let recBalance = data.txtBalance === "Receivable" ? Math.abs(data.totalOutCome) || 0 : 0;
        let payableBalance = data.txtBalance === "Payable" ? Math.abs(data.totalOutCome) || 0 : 0;
        let newData = {
          'Sr No.': data.srNo,
          'Party Name': data.party_name,
          'Email': data.party_email_id,
          'Phone No.': data.party_contact_no,
          'Receivable Balance': numberFormat(recBalance),
          'Payable Balance': numberFormat(payableBalance)
        }
          return newData;
      });


      _itemDetails.push({});
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"All Party Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_all_party_report'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># All Party Report</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-3">
                          <span>Date Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-3">
                          <span>Party : </span>
                          <div className="custom-dropdown">
                            <div className="custom-dropdown-btn" onClick={this.togglePartyDropdown}>
                              <span>{this.state.selectedPartyName}</span>
                              <span>▼</span>
                            </div>
                            {this.state.showPartyDropdown && (
                              <div className="custom-dropdown-menu">
                                <div
                                  className={`custom-dropdown-item ${this.state.selectedPartyId === "0" ? "selected" : ""}`}
                                  onClick={() => this.handlePartyFilter("0", "All Parties")}
                                >
                                  All Parties
                                </div>
                                {this.state.partyArrayList.map((party) => (
                                  <div
                                    key={party.party_id}
                                    className={`custom-dropdown-item ${this.state.selectedPartyId === String(party.party_id) ? "selected" : ""}`}
                                    onClick={() => this.handlePartyFilter(String(party.party_id), party.party_name)}
                                  >
                                    {party.party_name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <span>Group : </span>
                          <div className="custom-dropdown">
                            <div className="custom-dropdown-btn" onClick={this.toggleGroupDropdown}>
                              <span>{this.state.selectedGroupName}</span>
                              <span>▼</span>
                            </div>
                            {this.state.showGroupDropdown && (
                              <div className="custom-dropdown-menu">
                                <div
                                  className={`custom-dropdown-item ${this.state.selectedGroupId === "0" ? "selected" : ""}`}
                                  onClick={() => this.handleGroupFilter("0", "All Groups")}
                                >
                                  All Groups
                                </div>
                                {this.state.partyGroupArray.map((group) => (
                                  <div
                                    key={group.id}
                                    className={`custom-dropdown-item ${this.state.selectedGroupId === String(group.id) ? "selected" : ""}`}
                                    onClick={() => this.handleGroupFilter(String(group.id), group.name)}
                                  >
                                    {group.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>                        
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
                       
          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">All Party Report</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                        <i className="fa fa-plus-circle"></i> Add Sale
                    </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100 , 500]}
                      entries={25}
                      pagesAmount={4}
                      span
                      //pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
